import { render, staticRenderFns } from "./PlantVarietyOwnerList.vue?vue&type=template&id=6b1148dc&"
import script from "./PlantVarietyOwnerList.vue?vue&type=script&lang=js&"
export * from "./PlantVarietyOwnerList.vue?vue&type=script&lang=js&"
import style0 from "./PlantVarietyOwnerList.vue?vue&type=style&index=0&id=6b1148dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports